import Swal from "sweetalert2";
const alertaIcon = require("assets/img/icons/alerta_roja.png");
const errorIcon = require("assets/img/icons/inactivo.png");

const SwalMod = Swal.mixin({
    customClass: {
        actions: "d-flex justify-content-center gap-2rem",
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-outline-dark",
        content: "d-flex justify-content-center mb-4 text-sm",
        title: "verde-primario",
    },
    buttonsStyling: false,
    focusConfirm: false,
    focusCancel: false,
});

export const DecisionSwal = (
    text,
    confirmText,
    cancelText,
    onConfirm,
) => {
    SwalMod.fire({
        title: "¡ADVERTENCIA!",
        text,
        imageUrl: alertaIcon,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            onConfirm();
        }
    });
};

export const DecisionSwalHtml = (
    html,
    confirmText,
    cancelText,
    onConfirm,
) => {
    SwalMod.fire({
        title: "¡ADVERTENCIA!",
        html,
        imageUrl: alertaIcon,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            onConfirm();
        }
    });
};

export const ErrorSwalHtml = (html, cancelText) => {
    SwalMod.fire({
        title: "ERROR",
        html,
        imageUrl: errorIcon,
        showCancelButton: true,
        cancelButtonText: cancelText,
        reverseButtons: true,
        showConfirmButton: false,
    }).then((result) => {
        if (result.value) {
            onConfirm();
        }
    });
};
